export const CURRENCIES = [
  { code: 'USD', symbol: '$', name: 'US Dollar', decimals: 2 },
  { code: 'EUR', symbol: '€', name: 'Euro', decimals: 2 },
  { code: 'GBP', symbol: '£', name: 'British Pound', decimals: 2 },
  { code: 'NGN', symbol: '₦', name: 'Nigerian Naira', decimals: 0 },
  { code: 'UGX', symbol: 'USh', name: 'Ugandan Shilling', decimals: 0 },
  { code: 'GHS', symbol: 'GH₵', name: 'Ghana Cedi', decimals: 2 },
  { code: 'XOF', symbol: 'CFA', name: 'CFA Franc', decimals: 0 },
];

export const currencyMeta = (code) => CURRENCIES.find((c) => c.code === code) || CURRENCIES[0];

export const getStoredCurrency = () => localStorage.getItem('rtr_currency') || 'USD';

export const formatFx = (fx, rmb, code) => {
  const cur = fx?.currencies?.[code];
  if (!cur || !rmb) return null;
  const meta = currencyMeta(code);
  const value = rmb / cur.rmb_per_unit;
  return `${meta.symbol}${value.toLocaleString('en-US', { minimumFractionDigits: meta.decimals, maximumFractionDigits: meta.decimals })} ${code}`;
};
